<template>
  <div id="newSurvey">
    <topBar :title="$t('newSurvey.statistic')" />
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition">
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="82px">
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="'问卷' + $t('survey.name') + '：'" style="width: 100%;">
                                  <el-autocomplete style="width: 100%;" size="mini" v-model="filterForm.questionnaireName" :fetch-suggestions="fetchCondition"
              :placeholder="$t('survey.chooseName')" @select="handleSelect2" clearable>
            </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('newSurvey.publishTime') + '：'" style="width: 100%;">
                    <el-date-picker size="mini" v-model="filterForm.date" type="daterange" align="left" unlink-panels
                      range-separator=" - " :start-placeholder="$t('survey.startTime')"
                      :end-placeholder="$t('survey.endTime')" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="'任务名称：'" style="width: 100%;">
                    <el-input size="mini" v-model="filterForm.taskName" :placeholder="'请输入任务名称'"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="'任务时间：'" style="width: 100%;">
                    <el-date-picker size="mini" v-model="filterForm.date2" type="daterange" align="left" unlink-panels
                      range-separator=" - " :start-placeholder="$t('survey.startTime')"
                      :end-placeholder="$t('survey.endTime')" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="区域：" style="width: 100%;">
                    <el-select size="mini" v-model="filterForm.regionNos" multiple
                      :placeholder="$t('filters.chooseRegion')" @visible-change="resetFilters()" class="filterSelect">
                      <el-option v-for="item in options.regions" :key="item.itemValue" :label="item.itemLabel"
                        :value="item.itemValue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="省份：" style="width: 100%;">
                    <el-select size="mini" v-model="filterForm.provinceNos" multiple
                      :placeholder="$t('filters.chooseProvince')" @visible-change="resetFilters()" class="filterSelect">
                      <el-option v-for="item in options.provinces" :key="item.itemValue" :label="item.itemLabel"
                        :value="item.itemValue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市：" style="width: 100%;">
                    <el-select size="mini" v-model="filterForm.cityNos" multiple :placeholder="$t('filters.chooseCity')"
                      @visible-change="resetFilters()" class="filterSelect">
                      <el-option v-for="item in options.cities" :key="item.itemValue" :label="item.itemLabel"
                        :value="item.itemValue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="客户：" style="width: 100%;">
                    <el-select size="mini" v-model="filterForm.resellerNos" multiple
                      :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()" class="filterSelect">
                      <el-option v-for="item in options.resellers" :key="item.itemValue" :label="item.itemLabel"
                        :value="item.itemValue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="二级客户：" style="width: 100%;">
                    <el-select size="mini" v-model="filterForm.subResellers" multiple
                      :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()" class="filterSelect">
                      <el-option v-for="item in options.subResellers" :key="item.itemValue" :label="item.itemLabel"
                        :value="item.itemValue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="'门店编号：'" style="width: 100%;">
                    <el-input size="mini" v-model="filterForm.posId" :placeholder="'请输入门店编号'"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="'门店名称：'" style="width: 100%;">
                    <el-input size="mini" v-model="filterForm.doorName" :placeholder="'请输入名店名称'"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="24">
                <div class="filterBtns">
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset">{{ $t('reset') }}</el-button>
                  <el-button type="primary" style="float:right" @click="onExportList">{{ '图片导出记录' }}</el-button>
                  <el-button type="primary" style="float:right" @click="doneExportImage">{{ '图片导出' }}</el-button>
                  <el-button type="primary" style="float:right" @click="onExport">{{ '任务导出' }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table :data="tableData" style="width: 100%" :key="1" v-loading="tableLoading">
              <el-table-column prop="questionnaireName" :label="'问卷名称'" width="200">
              </el-table-column>
              <el-table-column prop="publishedTime" :label="'问卷发布时间'" width="120">
              </el-table-column>
              <el-table-column prop="taskName" :label="'任务名称'" width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button @click="showDetail(scope.row.id)" type="text">{{
                    scope.row.taskName }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="createName2" :label="'创建人'">
              </el-table-column>
              <el-table-column prop="startTime" :label="'任务开始时间'" width="120">
              </el-table-column>
              <el-table-column prop="endTime" :label="'任务截止时间'" width="120">
              </el-table-column>
              <el-table-column prop="regionName" :label="'区域'">
              </el-table-column>
              <el-table-column prop="provinceName" :label="'省份'">
              </el-table-column>
              <el-table-column prop="cityName" :label="'城市'">
              </el-table-column>
              <el-table-column prop="resellerName" :label="'客户'" width="120">
              </el-table-column>
              <el-table-column prop="subReseller" :label="'二级客户'">
              </el-table-column>
              <el-table-column prop="posId" :label="'门店编号'">
              </el-table-column>
              <el-table-column prop="doorName" :label="'门店名称'" width="250">
              </el-table-column>
              <el-table-column prop="submitName2" :label="'任务提交人'" width="100">
              </el-table-column>
              <el-table-column prop="submitProgress" :label="'检查项提交进度'" width="100">
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination background @current-change="currentChange" :current-page="current"
                layout="total, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <el-dialog :title="'任务详情'" :visible.sync="showFlag" width="80%" :close-on-click-modal="false">
      <div style="width:100%"><span style="width:100px">门店名称：</span>{{ currentData.doorName }}</div>
      <div style="width:100%;margin-top: 10px;"><span style="width:100px">任务名称：</span>{{ currentData.name }}</div>
      <div style="width:100%;margin-top: 10px;border-top: 1px solid #636363;" v-for="item in currentData.items"
        :key="item.id">
        <div style="width:100%;margin-top: 10px;"><span style="width:100px">检查项描述：</span>{{ item.content }}</div>
        <div style="width:100%;margin-top: 10px;">
          <el-row :gutter="20">
            <el-col :span="6" v-for="(image, index) in item.images" :key="item.id + '-images' + index">
              <el-image style="width: 100%;height: 11vw;background-color: lightgray;" :key="item.id + '-image-' + index"
                :src="image" lazy :preview-src-list="[image]" :fit="'contain'">
                <div slot="error" class="image-slot">
                  <div style="width: 100%;height: 11vw;display: flex;justify-content: center;align-items: center;">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </div>
              </el-image>
            </el-col>
          </el-row>
        </div>
        <div
          style="width:calc(100% - 20px);margin-top: 10px;border: 1px solid #ebeef5;padding: 10px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);"
          v-show="item.submitCount > 0 && item.feedBackImages.length > 0">
          <div style="width:100%;position: relative;"><span style="width:100px">门店响应描述：</span>
            {{ item.feedBack }}
            <div style="position: absolute;bottom: 0;right:10px">
              <el-button size="mini" disabled style="height: 20px;line-height: 20px;padding: 0;width: 60px;">{{
                item.status == 0 ? '未提交' : item.status == -1 || item.status == 1 ? '待审核' : item.status == 3 ? '未通过' :
                  '通过'
              }}</el-button>
            </div>
          </div>
          <div style="width:100%;margin-top: 10px;">
            <el-row :gutter="20">
              <el-col :span="6" v-for="(image, index) in item.feedBackImages" :key="item.id + '-images2-' + index">
                <el-image style="width: 100%;height: 11vw;background-color: lightgray;"
                  :key="item.id + '-image2-' + index" :src="image" lazy :preview-src-list="[image]" :fit="'contain'">
                  <div slot="error" class="image-slot">
                    <div style="width: 100%;height: 11vw;display: flex;justify-content: center;align-items: center;">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </div>
                </el-image>
              </el-col>
            </el-row>
          </div>
          <div style="width:100%;margin-top: 10px;"><span style="width:100px">审核留言：</span>{{ item.message }}</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="'图片导出记录'" :visible.sync="showImageFlag" width="80%" @closed="closeShowImage" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="问卷名称:">
          <div style="display: inline-flex;">
            <el-autocomplete style="width: 420px;" v-model="filterName" :fetch-suggestions="fetchCondition"
              placeholder="请输入并选择问卷名" @select="handleSelect" clearable>
            </el-autocomplete>
          </div>
          <el-button @click="listExportTask" style="float: right;" type="success">查询记录</el-button>
        </el-form-item>
      </el-form>


      <div style="margin-top: 20px">
        <el-table :data="tableData2" style="width: 100%" :key="1" v-loading="tableLoading2" >
          <el-table-column prop="id" :label="'ID'" width="50" align="center">
          </el-table-column>
          <!-- <el-table-column prop="questionnaireName" :label="'问卷名称'">
          </el-table-column> -->
          <el-table-column prop="condition" :label="'导出条件'" align="left" header-align="center" width="500">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="24"><div v-if="scope.row.questionnaireName">问卷名称: {{ scope.row.questionnaireName }}</div></el-col>
                <el-col :span="24"><div v-if="scope.row.conditionQuery&&scope.row.conditionQuery.publishStartTime">发布时间: {{ scope.row.conditionQuery.publishStartTime }} ~ {{ scope.row.conditionQuery.publishEndTime }}</div></el-col>
                <el-col :span="24"><div v-if="scope.row.conditionQuery&&scope.row.conditionQuery.taskName">任务名称: {{ scope.row.conditionQuery.taskName }}</div></el-col>
                <el-col :span="24"><div v-if="scope.row.conditionQuery&&scope.row.conditionQuery.startTime">任务时间: {{ scope.row.conditionQuery.startTime }} ~ {{ scope.row.conditionQuery.endTime }}</div></el-col>
                                <el-col :span="24"><div v-if="scope.row.conditionQuery&&scope.row.conditionQuery.posId">门店编号: {{ scope.row.conditionQuery.posId}}</div></el-col>
                <el-col :span="24"><div v-if="scope.row.conditionQuery&&scope.row.conditionQuery.doorName">门店名称: {{ scope.row.conditionQuery.doorName }}</div></el-col>
                <el-col :span="24"><div v-if="scope.row.conditionQuery&&scope.row.conditionQuery.regionNos.length>0">区域:
                  <el-tag v-for="item in options.regions.filter(r=>scope.row.conditionQuery.regionNos.includes(r.itemValue))" size="mini" :key="item.itemValue">{{item.itemLabel}}</el-tag>
                </div></el-col>
                <el-col :span="24"><div v-if="scope.row.conditionQuery&&scope.row.conditionQuery.provinceNos.length>0">省份:
                                    <el-tag v-for="item in options.provinces.filter(r=>scope.row.conditionQuery.provinceNos.includes(r.itemValue))" size="mini" :key="item.itemValue">{{item.itemLabel}}</el-tag>
                </div></el-col>
                <el-col :span="24"><div v-if="scope.row.conditionQuery&&scope.row.conditionQuery.cityNos.length>0">城市:
                                    <el-tag v-for="item in options.cities.filter(r=>scope.row.conditionQuery.cityNos.includes(r.itemValue))" size="mini" :key="item.itemValue">{{item.itemLabel}}</el-tag>
                </div></el-col>
                <el-col :span="24"><div v-if="scope.row.conditionQuery&&scope.row.conditionQuery.resellerNos.length>0">客户:
                                    <el-tag v-for="item in options.resellers.filter(r=>scope.row.conditionQuery.resellerNos.includes(r.itemValue))" size="mini" :key="item.itemValue">{{item.itemLabel}}</el-tag>
                </div></el-col>
                <el-col :span="24"><div v-if="scope.row.conditionQuery&&scope.row.conditionQuery.subResellers.length>0">二级客户:
                                    <el-tag v-for="item in options.subResellers.filter(r=>scope.row.conditionQuery.subResellers.includes(r.itemValue))" size="mini" :key="item.itemValue">{{item.itemLabel}}</el-tag>
                </div></el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="'导出时间'"  align="center">
          </el-table-column>
          <el-table-column prop="accountName" :label="'操作人'"  align="center">
          </el-table-column>
          <el-table-column prop="done" :label="'进度'"  align="center">
            <template slot-scope="scope">
              {{ showProgress(scope.row) }}
              <i class="el-icon-loading" v-show="!scope.row.done"></i>
            </template>
          </el-table-column>
          <el-table-column prop="done" :label="'操作'" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="downloadZip(scope.row.url)" :disabled="!scope.row.url">下载附件</el-button>

            </template>
          </el-table-column>
        </el-table>
        <div class="pagingBox">
          <el-pagination background @current-change="currentChange2" :current-page="current2"
            layout="total, prev, pager, next, jumper" :total="total2">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopBar from "../components/TopBar.vue";
import _ from "lodash";
export default {
  name: "StatisticList",
  components: {
    topBar: TopBar
  },
  data: function () {
    return {
      filterForm: {},
      initFilterForm: {
        questionnaireName: "", // 问卷名称
        date: "", // 日期
        date2: "",
        taskName: "",
        posId: "",
        doorName: "",
        regionNos: [],
        provinceNos: [],
        cityNos: [],
        resellerNos: [],
        subResellers: []
      },
      options: {
        regions: [],
        provinces: [],
        cities: [],
        resellers: [],
        subResellers: []
      },
      currentData: {
        doorName: "",
        name: "",
        items: []
      },
      tableData: [], // 表格数据
      total: 0,
      current: 1, // 当前页码
      filterName: "",
      tableData2: [], // 表格数据
      total2: 0,
      current2: 1, // 当前页码
      tableLoading: false,
      tableLoading2: false,
      showFlag: false,
      showExportFlag: false,
      showImageFlag: false,
      questionnaires: [],
      timerTask: {}
    };
  },

  async beforeMount() {
    this.published = Number(this.$route.query.published || 1);
    this.initFilterForm.published = this.published;
    let queryJson = localStorage.getItem("detailParams");
    if (queryJson) {
      let query = JSON.parse(queryJson);
      this.initFilterForm.date2 = query.startTime
        ? [query.startTime, query.endTime]
        : [];
      localStorage.removeItem("detailParams");
    } else {
      this.initFilterForm.date2 = this.$route.query.startTime
        ? [this.$route.query.startTime, this.$route.query.endTime]
        : "";
    }
    // await this.getCanDownload();
    this.onReset();
    this.onSearch();
    this.loadOption();
  },
  watch: {
    $route(val) {
      this.published = Number(this.$route.query.published || 1);
      this.initFilterForm.published = this.published;
      this.onReset();
      this.onSearch();
    }
  },
  computed: {
    // statusOptions () {
    //   return [{
    //     label: '已发布',
    //     value: true
    //   },
    //   {
    //     label: '未发布',
    //     value: false
    //   }]
    // },
    // canDownload: ({ $store: { getters } }) => {
    //   console.log(getters.canDownload)
    //   if (getters.canDownload + "" === "true") {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    isAdmin: ({ $store: { getters } }) => {
      if (getters.isAdmin + "" === "true") {
        return true;
      } else {
        return false;
      }
    } // 角色是否是admin
  },
  methods: {
    loadOption: async function () {
      let { data } = await window.instance.post(
        openSurveyReqUrl + "condition/doorFilters",
        {}
      );
      if (data.code === 200) {
        this.options = data.data;
      }
    },
    resetFilters: async function () {
      // this.options = {
      //   regions: [],
      //   provinces: [],
      //   cities: [],
      //   resellers: [],
      //   subResellers: []
      // }
      let { data } = await window.instance.post(
        openSurveyReqUrl + "condition/doorFilters",
        { ...this.filterForm }
      );
      if (data.code === 200) {
        this.options = data.data;
      }
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.current = 1;
      }
      this.tableLoading = true;
      let submitData = {
        publishStartTime: this.filterForm.date ? this.filterForm.date[0] : "",
        publishEndTime: this.filterForm.date ? this.filterForm.date[1] : "",
        startTime: this.filterForm.date2 ? this.filterForm.date2[0] : "",
        endTime: this.filterForm.date2 ? this.filterForm.date2[1] : "",
        size: 10,
        current: this.current,
        ...this.filterForm
      };
      let res = await window.instance.post(
        openSurveyReqUrl + "tasks/expand",
        submitData
      );
      res = res.data;
      if (res.code === 200) {
        const list = res.data.list;
        this.total = res.data.total;
        this.tableData = list;
      }
      this.tableLoading = false;
    },

    onExport: function () {
      let submitData = {
        publishStartTime: this.filterForm.date ? this.filterForm.date[0] : "",
        publishEndTime: this.filterForm.date ? this.filterForm.date[1] : "",
        startTime: this.filterForm.date2 ? this.filterForm.date2[0] : "",
        endTime: this.filterForm.date2 ? this.filterForm.date2[1] : "",
        size: 10,
        current: this.current,
        ...this.filterForm
      };
      this.$tool.exportFile({
        method: "post",
        url: openSurveyReqUrl + "tasks/expand/export",
        data: submitData
      });
    },
    onExportImage: async function () {
      this.showExportFlag = true;
    },
    onExportList: async function () {
      this.showImageFlag = true;
      await this.listExportTask();
    },
    handleSelect(item) {
      this.filterName = item.value;
    },
    handleSelect2(item) {
      this.filterForm.questionnaireName = item.value;
    },
    fetchCondition: function (qs, cb) {
      let that = this;
      window.instance
        .get(
          openSurveyReqUrl +
          "condition/questionnaires" +
          (qs ? "?name=" + qs : "")
        )
        .then(res => {
          res = res.data;
          that.questionnaires = res.data.list;
          cb(
            res.data.list.map(l => {
              return { label: l.itemValue, value: l.itemLabel };
            })
          );
        });
    },
    listExportTask: async function (reset) {
      if (reset) {
        this.current2 = 1;
      }
      let submitData = {
        // publishStartTime: this.filterForm.date ? this.filterForm.date[0] : "",
        // publishEndTime: this.filterForm.date ? this.filterForm.date[1] : "",
        // startTime: this.filterForm.date2 ? this.filterForm.date2[0] : "",
        // endTime: this.filterForm.date2 ? this.filterForm.date2[1] : "",
        name: this.filterName,
        size: 10,
        current: this.current2
        // ...this.filterForm
      };
      this.tableLoading2 = true;
      let res = await window.instance.post(
        openSurveyReqUrl + "tasks/expand/export/tasks",
        submitData
      );
      res = res.data;
      if (res) {
        const list = res.list;
        this.total2 = res.total;
        this.tableData2 = list;
      }
      this.tableLoading2 = false;
    },
    doneExportImage: async function () {
      if (this.questionnaires.filter(q => q.itemLabel === this.filterForm.questionnaireName).length === 0) {
        this.$message.error("问卷无效，请选择填入并选择有效的问卷名！")
        return;
      }

      let confirm = await this.$tool.secondConfirm(`确认后开始打包，打包完成后请进入图片导出记录进行下载!`);
      if (!confirm) return;

      let submitData = {
        publishStartTime: this.filterForm.date ? this.filterForm.date[0] : "",
        publishEndTime: this.filterForm.date ? this.filterForm.date[1] : "",
        startTime: this.filterForm.date2 ? this.filterForm.date2[0] : "",
        endTime: this.filterForm.date2 ? this.filterForm.date2[1] : "",
        size: 10,
        current: this.current,
        ...this.filterForm
      };
      let res = await window.instance.post(
        openSurveyReqUrl + "tasks/expand/export/images",
        submitData
      );
      res = res.data
      // console.log(res)
      if(res.code&&res.code===404){
        this.$message.error(res.message)
        return
      }
    },
    currentChange: function (index) {
      // 分页
      this.current = index;
      this.onSearch(false);
    },
    currentChange2: function (index) {
      // 分页
      this.current2 = index;
      this.listExportTask(false);
    },
    onReset: async function () {
      this.filterForm = _.cloneDeep(this.initFilterForm);
      await this.loadOption();
    },
    showProgress: function (item) {
      let that = this
      if (item.done) {
        return "打包成功"
      }

      if (!this.timerTask[item.id]) {
        this.timerTask[item.id] = setInterval(async function () {
          let res = await window.instance.post(openSurveyReqUrl + "tasks/expand/export/" + item.id + "/status")
          res = res.data.data;
          if (res) {
            item.done = true
            item.url = res
            clearInterval(that.timerTask[item.id])
            delete that.timerTask[item.id]
          }
        }, 5000)
      }
      return "打包中"
    },
    closeShowImage: function () {
      let that = this
      Object.keys(this.timerTask).forEach(k => {
        if (that.timerTask[k]) {
          clearInterval(that.timerTask[k])
          delete that.timerTask[k]
        }
      })
    },
    downloadZip: function (url) {
      location.href = url;
    },
    // getCanDownload: async function () {
    //     let { data } = await window.instance.get(
    //         openSurveyReqUrl + "account/canViewReport"
    //     );
    //     this.canDownload = data.data.result;
    // },
    showDetail: async function (id) {
      let res = await window.instance.get(openSurveyReqUrl + "tasks/" + id);

      res = res.data;
      console.log(res.data)
      if (res.code === 200) {
        this.currentData = res.data;
        console.log(this.currentData)
      }
      this.showFlag = true;
    }
  }
};
</script>

<style scoped lang="sass">
</style>



// WEBPACK FOOTER //
// src/openSurvey/pages/TaskManage.vue